import { AppBar, Toolbar, Typography, Box } from "../shared/utils/muiImports";
import { Link } from "react-router-dom";
import SettingsIcon from "@mui/icons-material/Settings";
import BuildIcon from "@mui/icons-material/Build";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";

const HeaderBar = () => {  
  return (
    <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
      <Toolbar>
        {/* Left-side Title */}
        <Typography
          variant="h6"
          noWrap
          component={Link}
          to="/"
          sx={{
            textDecoration: "none",
            color: "inherit",
            flexGrow: 1,
            display: "flex",
            alignItems: "center",
            "&:hover": {
              textDecoration: "none",
            },
          }}
        >
          Hospital Management System
          <LocalHospitalIcon sx={{ marginLeft: 1, verticalAlign: "middle" }} />
        </Typography>

        {/* Right-side Links */}
        <Box sx={{ display: "flex", gap: 4, alignItems: "center" }}>
          <Typography
            variant="body1"
            onClick={() => (window.location.href = "/settings-ui/")}
            sx={{
              textDecoration: "none",
              color: "inherit",
              "&:hover": { textDecoration: "underline" },
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
            }}
          >
            <BuildIcon sx={{ marginRight: 1 }} />
            Settings
          </Typography>

          <Typography
            variant="body1"
            onClick={() => (window.location.href = "/configuration-ui/")}
            sx={{
              textDecoration: "none",
              color: "inherit",
              "&:hover": { textDecoration: "underline" },
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
            }}
          >
            <SettingsIcon sx={{ marginRight: 1 }} />
            Configurations
          </Typography>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default HeaderBar;
